/**
 * Nesse arquivo vamos criar algumas funções e constantes para definir campos readonly
 * na cotação com base no ERP utilizado.
 */

const ERP_CAMPOS_HIDDEN_MAP = {
  CASA_SHOPPING: {
    camposItens: ['centroCusto'],
  },
};

const ERP_CAMPOS_OBRIGATORIOS_MAP = {
  CASA_SHOPPING: {
    campos: ['centroCusto'],
  },
};

const ERP_CAMPOS_READONLY_MAP = {
  SENIOR_MEGA: {
    campos: ['centroCusto', 'projeto'],
    camposItens: ['centroCusto', 'projeto'],
  },
};

/**
 * Retorna uma promise para simular uma request e ficar mais fácil de lidar com isso depois
 * @param erpCamposIntegracao
 * @returns {Promise<Awaited<*>|Awaited<null>>}
 */
const getCamposReadonly = async (erpCamposIntegracao) => {
  const camposReadonly = ERP_CAMPOS_READONLY_MAP[erpCamposIntegracao];
  if (!camposReadonly) {
    return Promise.resolve(null);
  }
  return Promise.resolve(camposReadonly);
};

/**
 * Retorna uma promise para simular uma request e ficar mais fácil de lidar com isso depois
 * @param erpCamposIntegracao
 * @returns {Promise<Awaited<*>|Awaited<null>>}
 */
const getCamposObrigatorios = async (erpCamposIntegracao) => {
  const camposObrigatorios = ERP_CAMPOS_OBRIGATORIOS_MAP[erpCamposIntegracao];
  if (!camposObrigatorios) {
    return Promise.resolve(null);
  }
  return Promise.resolve(camposObrigatorios);
};

/**
 * Retorna uma promise para simular uma request e ficar mais fácil de lidar com isso depois
 * @param erpCamposIntegracao
 * @returns {Promise<Awaited<*>|Awaited<null>>}
 */
const getCamposHidden = async (erpCamposIntegracao) => {
  const camposHidden = ERP_CAMPOS_HIDDEN_MAP[erpCamposIntegracao];
  if (!camposHidden) {
    return Promise.resolve(null);
  }
  return Promise.resolve(camposHidden);
};

export default {
  getCamposReadonly,
  getCamposHidden,
  getCamposObrigatorios,
};
